<template>
    <Update></Update>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const Update = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/EngineeringWorkbench/Update.vue"
    )
);

export default {
    name: "Project_HelpUpdate", //The name you are in should not equal the name of the component you are importing.
    components: { Update, AuthLayout },
};
</script>
